"use client";
import "../../../chunk-MMUBH76A.js";
import { jsx } from "react/jsx-runtime";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
const AnimatedHeightWrapper = ({ children, className }) => {
  const containerRef = useRef(null);
  const [height, setHeight] = useState("auto");
  useEffect(() => {
    if (containerRef.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        const observedHeight = entries[0].contentRect.height;
        setHeight(observedHeight);
      });
      resizeObserver.observe(containerRef.current);
      return () => {
        resizeObserver.disconnect();
      };
    }
  }, []);
  return /* @__PURE__ */ jsx(Container, { className, style: { height }, animate: { height }, transition: { duration: 0.2 }, children: /* @__PURE__ */ jsx("div", { ref: containerRef, children }) });
};
const Container = styled(motion.div)`
  overflow: hidden;
`;
export {
  AnimatedHeightWrapper
};
